<template>
  <div>
    <b-modal
      id="merge-cases-modal"
      ref="merge-cases-modal"
      cancel-variant="outline-secondary"
      centered
      :title="$t('DEBTIA_CONFIRM_MERGE')"
      size="md"
      hide-footer
      no-close-on-backdrop
      @close="cancelModal"
    >
      <b-overlay
        id="overlay-background"
        :show="modaalLoader"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="secondary"
        spinner-medium
      >
        <b-alert
          v-if="errorMsg"
          variant="danger"
          show
        >
          <div class="alert-body">
            <span>{{ errorMsg }}</span>
          </div>
        </b-alert>
        <b-row class="justify-content-center text-center">
          <b-col cols="12">
            <p>
              {{ $t('DEBTIA_WARNING_YOU_HAVE_SELECTED') }}
              <strong>{{ selectedMainCase.value }}</strong>
              {{ $t('DEBTIA_CASE_HAVE_DIFFERENT_DEBTORS') }}
            </p>
          </b-col>
        </b-row>
        <b-row class="justify-content-center text-center mb-3">
          <b-col cols="12">
            <p class="mb-2">
              {{ $t('DEBTIA_FOLLOWING_CASES_HAVE_DIFFERENT_DEBTORS') }}
            </p>
            <div v-if="compareData && compareData.cases && compareData.cases.length">
              <span
                v-for="(item, index) in compareData.cases"
                :key="index"
                class="cases-item"
              >
                {{ item }}{{ index >= compareData.cases.length - 1 ? '' : ',' }}
              </span>
            </div>
          </b-col>
        </b-row>

        <div class="d-flex justify-content-between mt-4">
          <b-button
            variant="success"
            class="mr-2"
            @click="proceedMerge(true)"
          >
            {{ $t('DEBTIA_PROCEED_MERGE') }}
          </b-button>
          <b-button
            variant="primary"
            class="mr-2"
            @click="proceedMerge(false)"
          >
            {{ $t('DEBTIA_MERGE_WITH_DEBTORS') }}
          </b-button>
          <b-button
            variant="danger"
            @click="cancelModal"
          >
            {{ $t('DEBTIA_CANCEL') }}
          </b-button>
        </div>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {
  BOverlay,
  BButton,
  BRow,
  BCol,
  BAlert,
} from 'bootstrap-vue'
import constants from '@/app-configs/constants'
import axios from '@axios'
import { EventBus } from '@/event-bus'
import i18n from '@/libs/i18n'

export default {
  components: {
    BOverlay,
    BButton,
    BRow,
    BCol,
    BAlert,
  },
  props: {
    compareData: {
      validator(value) {
        return Array.isArray(value) || typeof value === 'object'
      },
      required: true,
    },
    selectedMainCase: {
      type: Object,
      required: true,
    },
    selectedCases: {
      type: Array,
      required: true,
    },
    userData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      skip_debtor_merge: false,
      modaalLoader: false,
      errorMsg: '',
    }
  },
  methods: {
    proceedMerge(skipDebtorMerge) {
      this.modaalLoader = true
      const url = `${constants.baseUrl}/debt-cases/merge`
      let filterCaseIds = []
      if (Array.isArray(this.compareData.case_ids)) {
        filterCaseIds = this.compareData.case_ids.filter(id => id !== this.selectedMainCase.value)
      } else if (typeof this.compareData.case_ids === 'object') {
        filterCaseIds = Object.values(this.compareData.case_ids).filter(id => id !== this.selectedMainCase.value)
      }
      axios.post(url, {
        main_case_id: this.selectedMainCase.value || null,
        creditor_id: this.userData.data.id || null,
        case_ids: filterCaseIds || null,
        skip_debtor_merge: skipDebtorMerge,
      })
        .then(response => {
          this.modaalLoader = false
          if (response.status === 200) {
            EventBus.$emit('client-updated')
            this.$refs['merge-cases-modal'].hide()
            EventBus.$emit('merge-success')
            this.$swal({
              icon: 'success',
              title: i18n.t('DEBTIA_CASE_MERGED'),
              text: response.data.message,
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
          }
        }).catch(error => {
          this.modaalLoader = false
          const [fistMessage] = error.response.data.message
          this.errorMsg = fistMessage
        })
    },
    cancelModal() {
      this.errorMsg = ''
      this.$refs['merge-cases-modal'].hide()
    },
  },
}
</script>
